import { render } from "./GibergArt.vue?vue&type=template&id=f0f56a26&scoped=true"
import script from "./GibergArt.vue?vue&type=script&lang=js"
export * from "./GibergArt.vue?vue&type=script&lang=js"

import "./GibergArt.vue?vue&type=style&index=0&id=f0f56a26&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f56a26"]])

export default __exports__